import { Grid, Typography } from '@mui/material';

interface FeedDefinitionInfoItemProps {
  leftNode: React.ReactNode;
  rightNode: React.ReactNode;
}

export const FeedDefinitionInfoItem = ({
  leftNode,
  rightNode,
}: FeedDefinitionInfoItemProps) => {
  return (
    <>
      <Grid item xs={3}>
        <Typography variant="caption" color="inherit" display="block">
          {leftNode}
        </Typography>
      </Grid>
      <Grid item xs={9}>
        <Typography variant="caption" color="inherit" display="block">
          {rightNode}
        </Typography>
      </Grid>
    </>
  );
};
